import React, { useContext, useRef } from "react";
import { useEffect, useState } from "react";
import "./opportunitiesDetails.scss";
// import OPPDCss from "./OpportunitiesDetails.module.scss";
import "react-quill/dist/quill.snow.css";
import Sidebar from "../../Sidebar";
import Loader from "../../../../components/Loader/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DashNavbar from "../../DashNavbar";
import UserContext from "../../../../context/UserContext";

function OpportunitiesDetail() {
  const { tokenPayload } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const inv_id = location?.state?.opportunities;

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  //   const [opportunitiesDetial, setOpportunitiesDetial] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  //   function for fetching the investment details
  const fetchOpportunitiesDetail = async () => {
    setLoading(true);
    if (!inv_id) {
      navigate("/dashboard/Opportunities");
    }
    const url = `https://ballersapi.ballerslife.co/api/v1/member/get_investment_details?inv_deal_id=${inv_id}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Access-Control-Allow-Origin": "*",
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok.");
      }
      const data = await response.json();
      if (response.status === 200) {
        setLoading(false);
        setData(data);
        if (data.investment_commitment === true) {
          setSelectedOption(
            data.investment_commitment_details.investment_commitment
          );
          setInputValue(data.investment_commitment_details.investment_amount);
        }

        console.log("data", data);
      } else if (response.status === 401) {
        toast.error(data.detail);
        navigate("/");
      } else if (response.status === 403) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        navigate("/login");
        window.location.reload();
        setLoading(false);
      } else {
        toast.error(data.detail);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [selectedOption, setSelectedOption] = useState("");
  const [inputValue, setInputValue] = useState("");

  // const handleCheckboxChange = (value) => {
  //   setSelectedOption(value);
  //   if (value === "no") {
  //     setInputValue("0");
  //   } else {
  //     setInputValue("30000");
  //   }
  // };
  const handleCheckboxChange = (value) => {
    if (data.investment_commitment == true) {
      setSelectedOption(value);
      console.log("1", value);
      if (value === "No") {
        setInputValue("0");
      } else if (value === "Yes") {
        setInputValue("30000");
      } else {
        setInputValue("30000");
      }
      setData((prevData) => ({
        ...prevData,
        investment_commitment_details: {
          ...prevData.investment_commitment_details,
          investment_commitment: value,
          investment_amount:
            value === "No" ? "0" : value === "Yes" ? "30000" : "30000", // Automatically set amount based on selection
        },
      }));
    } else {
      console.log("2", value);
      setSelectedOption(value);
      if (value === "No") {
        setInputValue("0");
      } else if (value === "Yes") {
        setInputValue("30000");
      } else {
        setInputValue("30000");
      }
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = async () => {
    const url = `https://ballersapi.ballerslife.co/api/v1/member/investment_commitment_details?inv_deal_id=${inv_id}&investment_commitment=${
      selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)
    }&investment_amount=${inputValue}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        // toast.success(data.detail);
        fetchOpportunitiesDetail();
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const formatNumber = (num) => {
    let formattedNumber;
    if (num >= 1000000000) {
      formattedNumber = (num / 1000000000).toFixed(1) + "B";
    } else if (num >= 1000000) {
      formattedNumber = (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      formattedNumber = (num / 1000).toFixed(1) + "K";
    } else {
      return num.toString();
    }

    // Remove the .0 if present
    if (
      formattedNumber.endsWith(".0K") ||
      formattedNumber.endsWith(".0M") ||
      formattedNumber.endsWith(".0B")
    ) {
      formattedNumber =
        formattedNumber.slice(0, -3) + formattedNumber.slice(-1);
    }

    return formattedNumber;
  };
  useEffect(() => {
    if (inv_id === undefined) {
      navigate("/dashboard/opportunities");
    } else {
      fetchOpportunitiesDetail();
    }
  }, [inv_id]);

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        <div className="user">
          <div className="svgMain" onClick={handleSvg}>
            {hideSvg ? (
              <div className="closeSvg"></div>
            ) : (
              <div className="hamburgerSvg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0F0223"
                  stroke="#eee2e2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-menu"
                >
                  <line x1="4" x2="20" y1="12" y2="12" />
                  <line x1="4" x2="20" y1="6" y2="6" />
                  <line x1="4" x2="20" y1="18" y2="18" />
                </svg>
              </div>
            )}
          </div>

          <div className="userSec">
            {hideSvg ? (
              <div onClick={handleSvg}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#0F0223"
                  stroke="#eee2e2"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-x-square"
                >
                  <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                  <path d="m15 9-6 6" />
                  <path d="m9 9 6 6" />
                </svg>
              </div>
            ) : (
              <>
                <DashNavbar />
              </>
            )}
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div>
              <div className="goBackSvgOppor">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#FFBF00"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-chevron-left"
                  onClick={() => {
                    navigate("/dashboard/opportunities");
                  }}
                >
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </div>
              <div
                className="opportunitiesImgMain"
                style={{
                  justifyContent: data.investment_commitment
                    ? "center"
                    : "space-around",
                  padding: data.investment_commitment ? "0" : "20px",
                }}
              >
                <div className="opportunitiesImgAndDetailSec">
                  <img
                    src={data.club_logo_url}
                    alt=""
                    className="opportunitiesLogo"
                  />
                  <div className="opprtunitiesDetail ">
                    <div className="invOverviewContOpp">
                      <p className="invOverviewContFirst">CLUB NAME :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: data?.club_name,
                        }}
                      >
                        {/* {data.club_name} */}
                      </p>
                    </div>
                    <div className="invOverviewContOpp">
                      <p className="invOverviewContFirst">SPORTS CATEGORY :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: data?.sport_category,
                        }}
                      >
                        {/* {data.sport_category} */}
                      </p>
                    </div>
                    <div className="invOverviewContOpp">
                      <p className="invOverviewContFirst">LEAGUE NAME :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: data?.league_name,
                        }}
                      >
                        {/* {data.league_name} */}
                      </p>
                    </div>
                    <div className="invOverviewContOpp">
                      <p className="invOverviewContFirst">
                        FUNDRAISING AMOUNT :
                      </p>
                      <p className="invOverviewContSecond ">
                        $ {formatNumber(data.fundraising_amount)}
                      </p>
                    </div>
                    <div className="invOverviewContOpp">
                      <p className="invOverviewContFirst">INVESTMENT TYPE :</p>
                      <p
                        className="invOverviewContSecond inpInfoMainSec"
                        dangerouslySetInnerHTML={{
                          __html: data?.investment_type,
                        }}
                      >
                        {/* {data.investment_type} */}
                      </p>
                    </div>
                  </div>
                </div>
                {data.investment_commitment ? (
                  <div className="interestedDivSec">
                    <p>Are you interested to invest in this deal?</p>
                    <div className="interestedOpt">
                      <div className="combText">
                        <input
                          type="checkbox"
                          name="option"
                          value="Yes"
                          checked={selectedOption === "Yes"}
                          onChange={() => handleCheckboxChange("Yes")}
                        />
                        <label htmlFor="Yes">Yes</label>
                      </div>
                      <div className="combText">
                        <input
                          type="checkbox"
                          name="option"
                          value="no"
                          checked={selectedOption === "No"}
                          onChange={() => handleCheckboxChange("No")}
                        />
                        <label htmlFor="No">No</label>
                      </div>
                      <div className="combText">
                        <input
                          type="checkbox"
                          name="option"
                          value="maybe"
                          checked={selectedOption === "Maybe"}
                          onChange={() => handleCheckboxChange("Maybe")}
                        />
                        <label htmlFor="Maybe">Maybe</label>
                      </div>
                    </div>
                    <p>Enter the amount (in $) :</p>
                    <div className="inpAndSub">
                      <input
                        type="text"
                        className="inpAndSubInput"
                        name="inputField"
                        value={
                          inputValue ||
                          data.investment_commitment_details.investment_amount
                        }
                        onChange={handleInputChange}
                      />
                      <button
                        onClick={() => {
                          handleSubmit();
                        }}
                        className="inpAndSubBtn"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="interestedDiv">
                    <div className="interestedDivSec">
                      <p>Are you interested to invest in this deal?</p>
                      <div className="interestedOpt">
                        <div className="combText">
                          <input
                            type="checkbox"
                            name="option"
                            value="Yes"
                            checked={selectedOption === "Yes"}
                            onChange={() => handleCheckboxChange("Yes")}
                          />
                          <label for="Yes">Yes</label>
                        </div>
                        <div className="combText">
                          <input
                            type="checkbox"
                            name="option"
                            value="No"
                            checked={selectedOption === "No"}
                            onChange={() => handleCheckboxChange("No")}
                          />
                          <label for="No">No</label>
                        </div>
                        <div className="combText">
                          <input
                            type="checkbox"
                            name="option"
                            value="Maybe"
                            checked={selectedOption === "Maybe"}
                            onChange={() => handleCheckboxChange("Maybe")}
                          />
                          <label for="Maybe">Maybe</label>
                        </div>
                      </div>
                      <p>Enter the amount (in $) :</p>
                      <div className="inpAndSub">
                        <input
                          type="text"
                          className="inpAndSubInput"
                          name="inputField"
                          value={inputValue}
                          onChange={handleInputChange}
                        />
                        <button
                          onClick={() => {
                            handleSubmit();
                          }}
                          className="inpAndSubBtn"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {data.investment_highlights === undefined ||
              data.investment_highlights === "NA" ||
              data.investment_highlights === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">
                      INVESTMENT HIGHTLIGHTS :
                    </p>
                    <p
                      className="invOverviewContSecond ql-editor"
                      dangerouslySetInnerHTML={{
                        __html: data?.investment_highlights,
                      }}
                    ></p>
                  </div>
                </div>
              )}
              {data.clubs_financials === undefined ||
              data.clubs_financials === "NA" ||
              data.clubs_financials === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">CLUB FIANANCIALS :</p>
                    <p
                      className="invOverviewContSecond ql-editor"
                      dangerouslySetInnerHTML={{
                        __html: data?.clubs_financials,
                      }}
                    ></p>
                  </div>
                </div>
              )}

              {/* Investment Thesis */}
              {data.investment_thesis === undefined ||
              data.investment_thesis === "NA" ||
              data.investment_thesis === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">INVESTMENT THESIS :</p>
                    <p
                      className="invOverviewContSecond ql-editor"
                      dangerouslySetInnerHTML={{
                        __html: data?.investment_thesis,
                      }}
                    ></p>
                  </div>
                </div>
              )}
              {/* Club Overview */}
              {data.club_overview === undefined ||
              data.club_overview === "NA" ||
              data.club_overview === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">CLUB OVERVIEW :</p>
                    <p
                      className="invOverviewContSecond ql-editor"
                      dangerouslySetInnerHTML={{
                        __html: data?.club_overview,
                      }}
                    ></p>
                  </div>
                </div>
              )}
              {/* Management Details */}
              {data.management_details === undefined ||
              data.management_details === "NA" ||
              data.management_details === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">MANAGEMENT DETAILS :</p>
                    <p
                      className="invOverviewContSecond ql-editor"
                      dangerouslySetInnerHTML={{
                        __html: data?.management_details,
                      }}
                    ></p>
                  </div>
                </div>
              )}
              {/* Future Plans */}
              {data.future_plans === undefined ||
              data.future_plans === "NA" ||
              data.future_plans === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">FUTURE PLANS :</p>
                    <p
                      className="invOverviewContSecond ql-editor"
                      dangerouslySetInnerHTML={{
                        __html: data?.future_plans,
                      }}
                    >
                      {/* {data.future_plans} */}
                    </p>
                  </div>
                </div>
              )}
              {/* Investment Terms */}
              {data.investment_terms === undefined ||
              data.investment_terms === "NA" ||
              data.investment_terms === "na" ? (
                ""
              ) : (
                <div className="invOverviewMain">
                  <div className="invOverviewContThird">
                    <p className="invOverviewContFirst">INVESTMENT TERMS :</p>
                    <p
                      className="invOverviewContSecond inpInfoMainSec"
                      dangerouslySetInnerHTML={{
                        __html: data?.investment_terms,
                      }}
                    >
                      {/* {data.investment_terms} */}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OpportunitiesDetail;
